"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.measureWeb = void 0;
const fonts_json_1 = __importDefault(require("./fonts.json"));
const known_components_json_1 = require("./known-components.json");
/**
 *
 * @param dom -> Global variable 'document'
 * @param options -> Options: ignore tags and blacklisted tags.
 * @param onElementMap -> Function onElementMap: invoked on every element analysed
 * @returns
 */
function measureWeb(dom, options, onElementMap) {
    return __awaiter(this, void 0, void 0, function* () {
        const ignoreThirdClassNameList = options.ignoreThirdClassNameList || [
            /^ht-.*/,
            /^blip-.*/,
            /^ui-helper.*/,
            /^onetrust.*/,
            /^optanon.*/,
            /^bot.*/,
            /^inbenta.*/,
        ];
        const ignoreThirdIdList = options.ignoreThirdIdList || [
            /^batBeacon.*/,
            /^_hjRemoteVars.*/,
            /^optano.*/,
            /^chc_ifram.*/,
            /^blip.*/,
            /^onetrust.*/,
            /^blue-tags-.*/,
            /^bot.*/,
            /^ht-.*/,
            /^hj.*/,
            /^blip.*/,
            /^bfPlayer.*/,
            /^inbenta.*/,
            /^mundiale.*/,
        ];
        const ignoreThirdNameList = options.ignoreThirdNameList || [/hj.*/];
        const ignoreTagNameList = options.ignoreTagNameList || [
            /^div$/,
            /^noscript$/,
            /^script$/,
            /^link$/,
            /^meta$/,
            /^head$/,
            /^style$/,
            /^main$/,
            /^article$/,
            /^section$/,
        ];
        const blackListTags = options.blackListTags || [
            /^iframe$/,
            /^acronym$/,
            /^applet$/,
            /^basefont$/,
            /^big$/,
            /^center$/,
            /^dir$/,
            /^frame$/,
            /^frameset$/,
            /^isindex$/,
            /^noframes$/,
            /^s$/,
            /^strike$/,
            /^tt$/,
            /^u$/,
        ];
        // @ts-ignore
        const isMondrianComponentsLibrary = window.MondrianVanilla || window.MondrianReact || window.MondrianVue || window.MondrianAngular;
        let isMondrianFontsLoaded = isMondrianComponentsLibrary;
        let bodyCopy = dom.body.cloneNode(true);
        let allDOMElements = bodyCopy.querySelectorAll("*");
        let report = yield getReport(allDOMElements);
        let mdnCSSVersion = "";
        let links = document.head.querySelectorAll("link");
        links.forEach((item) => {
            if (item.href.match(/mondrian.claro.com.br\/vanilla\/(pre-release\/\d\_\d\_\d\/)?mondrian-vanilla-/)) {
                let versionPatttern = item.href.match(/-((\d+[\.\_]\d+[\.\_]\d+)|(latest))\.\w+$/);
                mdnCSSVersion =
                    (item.href.match("pre-release") ? "Pre release:" : "") +
                        (versionPatttern ? versionPatttern[1] : item.href);
            }
            else if (!isMondrianFontsLoaded && item.href.match(/mondrian.claro.com.br\/fonts\/(pre-release\/\d\_\d\_\d\/)?mondrian-fonts-/)) {
                isMondrianFontsLoaded = true;
            }
        });
        function getReport(elements) {
            return __awaiter(this, void 0, void 0, function* () {
                let elementsByType = {
                    isMondrian: [],
                    isNotMondrian: [],
                    isMerged: [],
                    isIgnoredThird: [],
                    isIgnoredThirdChildren: [],
                    isIgnored: [],
                    everything: elements,
                    filtered: [],
                };
                // Map ignoreThird elements and ignoreTags before start:
                for (let i = 0, lgt = elements.length; i < lgt; i++) {
                    let status = $markTagsToIgnore(elements[i], ignoreThirdClassNameList, ignoreThirdIdList, ignoreThirdNameList, ignoreTagNameList);
                    if (status !== "isIgnoredThird" && status !== "isIgnored")
                        continue;
                    elementsByType[status].push(elements[i]);
                    elements[i].setAttribute("data-mondrian-checker-status", status);
                }
                // Map ignoreThirdChildren elements:
                elementsByType.isIgnoredThirdChildren = [
                    ...document.body.querySelectorAll(`[data-mondrian-checker-status="isIgnoredThird"] *`),
                ];
                for (let i = 0, lgt = elementsByType.isIgnoredThirdChildren.length; i < lgt; i++) {
                    elementsByType.isIgnoredThirdChildren[i].setAttribute("data-mondrian-checker-status", "isIgnoredThirdChildren");
                }
                elementsByType.isIgnoredThird = [
                    ...document.body.querySelectorAll(`[data-mondrian-checker-status="isIgnoredThird"]`),
                ];
                elementsByType.filtered = [
                    ...document.body.querySelectorAll('*:not([data-mondrian-checker-status="isIgnored"],[data-mondrian-checker-status="isIgnoredThird"],[data-mondrian-checker-status="isIgnoredThirdChildren"])'),
                ];
                // Map all elements:
                let filteredElements = elementsByType.filtered;
                for (let i = 0, lgt = filteredElements.length; i < lgt; i++) {
                    let status = $testString(filteredElements[i], blackListTags, elementsByType);
                    status !== "isIgnoredThird" &&
                        status !== "isIgnored" &&
                        elementsByType[status].push(filteredElements[i]);
                    onElementMap && onElementMap(filteredElements[i], status);
                }
                let countedNodes = elementsByType.filtered.length; // Elements not ignored (already filtered)
                let filteredElementsUsed = [];
                let filteredElementsUsedAll = [];
                for (let i = 0, lgt = elementsByType.isMondrian.length; i < lgt; i++) {
                    let current = elementsByType.isMondrian[i];
                    filteredElementsUsedAll = [
                        ...filteredElementsUsedAll,
                        ...(current.className.match(/mdn-[\w-]+/g) || []),
                    ];
                    if (current.className.match("mdn-isActive"))
                        continue;
                    if (current.className.match("mdn-Icon")) {
                        filteredElementsUsed.push("mdn-Icon");
                        continue;
                    }
                    filteredElementsUsed.push(current.tagName === 'IMG' ? 'mdn-Image' : current.classList[0]);
                    // @ts-ignore
                    if (current.tagName === 'IMG' && current.src.match('mondrian.claro.com.br')) {
                        // @ts-ignore
                        filteredElementsUsedAll.push(current.src);
                    }
                }
                filteredElementsUsed = [...new Set(filteredElementsUsed)];
                filteredElementsUsedAll = [...new Set(filteredElementsUsedAll)];
                const result = {
                    // new
                    href: window.location.href,
                    domain: window.location.hostname,
                    // @ts-ignore
                    brand: window.MondrianCurrentBrand,
                    statistics: {
                        quantity: {
                            isIgnoredQtd: elementsByType.isIgnored.length,
                            isIgnoredThirdChildrenQtd: elementsByType.isIgnoredThirdChildren.length,
                            isIgnoredThirdQtd: elementsByType.isIgnoredThird.length,
                        },
                        percentage: {
                            isMergedStat: (elementsByType.isMerged.length / countedNodes) * 100,
                            isMondrianStat: (elementsByType.isMondrian.length / countedNodes) * 100,
                            isNotMondrianStat: (elementsByType.isNotMondrian.length / countedNodes) * 100,
                        },
                    },
                    foundedLibraries: yield mapMondrianLibraries(filteredElementsUsedAll),
                };
                return result;
            });
        }
        function mapMondrianLibraries(components) {
            return __awaiter(this, void 0, void 0, function* () {
                const iconPattern = /(mdn\-Icon)|mondrian.claro.com.br\/icons/gm;
                const brandsPattern = "mondrian.claro.com.br/brands";
                const channelsPattern = "mondrian.claro.com.br/channels";
                const assetsPattern = "mondrian.claro.com.br/assets";
                const illustrationsPattern = "mondrian.claro.com.br/illustrations";
                let libraries = [
                    lookForComponents(components, illustrationsPattern, "Mondrian Illustrations"),
                    lookForComponents(components, iconPattern, "Mondrian Icons"),
                    lookForComponents(components, brandsPattern, "Mondrian Brands"),
                    lookForComponents(components, channelsPattern, "Mondrian Channels"),
                    lookForComponents(components, assetsPattern, "Mondrian Assets"),
                    yield lookForFontComponents("Mondrian Fonts")
                ];
                if (isMondrianComponentsLibrary) {
                    let libraryName = 'Mondrian ';
                    // @ts-ignore
                    libraryName += window.MondrianVanilla ? 'Vanilla' : (window.MondrianReact ? 'React' : (window.MondrianVue ? 'Vue' : (window.MondrianAngular ? 'Angular' : '?')));
                    libraries.push(removeIn(components, [iconPattern, brandsPattern, channelsPattern, assetsPattern], libraryName, isMondrianComponentsLibrary));
                }
                return libraries.filter(library => library);
            });
        }
        function removeIn(components, patterns, libraryTitle, isMondrianComponentsLibrary) {
            let results = components;
            let fakeComponents = [];
            for (let i = 0, lgt = patterns.length; i < lgt; i++) {
                results = results.filter((item) => !item.match(patterns[i]));
            }
            if (!results.length)
                return;
            if (isMondrianComponentsLibrary) {
                let fakeFiltered = findFakeComponents(results);
                results = fakeFiltered.components;
                fakeComponents = fakeFiltered.fakeComponents;
            }
            return {
                title: libraryTitle,
                fakeComponents,
                foundedComponents: [...new Set(results)]
            };
        }
        function findFakeComponents(components) {
            // const knownComponents:Array<String> = []
            const fakeComponents = [];
            const verifiedComponents = [];
            components.forEach((className, i) => {
                if (known_components_json_1.knownComponents.indexOf(className) >= 0) {
                    verifiedComponents.push(className);
                }
                else {
                    fakeComponents.push(className);
                }
            });
            return {
                components: verifiedComponents,
                fakeComponents
            };
        }
        function lookForComponents(components, pattern, libraryTitle) {
            let result = components.filter((item, index) => item.match(pattern));
            if (!result.length)
                return;
            return {
                title: libraryTitle,
                foundedComponents: [...new Set(result)]
            };
        }
        function lookForFontComponents(libraryTitle) {
            return __awaiter(this, void 0, void 0, function* () {
                if (!isMondrianFontsLoaded)
                    return;
                var knowedMondrianFonts = fonts_json_1.default.data;
                let ready = yield document.fonts.ready;
                return {
                    title: libraryTitle,
                    foundedComponents: knowedMondrianFonts.map((item, index) => {
                        if (document.fonts.check(`1em ${item}`)) {
                            return item;
                        }
                    }).filter(item => item)
                };
            });
        }
        function $markTagsToIgnore(element, ignoreThirdClassNameList, ignoreThirdIdList, ignoreThirdNameList, ignoreTagNameList) {
            let classList = typeof element.className === "string"
                ? element.className.split(" ") || []
                : [];
            let id = element.id || "";
            // @ts-ignore
            let name = element.name || "";
            let tagName = element.tagName.toLowerCase();
            if (element.tagName === "STRONG" && element.closest(".mdn-Text")) {
                return "isIgnored";
            }
            if ($findPattern(classList, [/mdn-.*/])) {
                // if is Mondrian, we cannot ignore (no matter what the tag is)
                return "isMondrian";
            }
            else if ($findPattern(id, ignoreThirdIdList) ||
                $findPattern(name, ignoreThirdNameList) ||
                $findPattern(classList, ignoreThirdClassNameList)) {
                return "isIgnoredThird";
            }
            else if ($findPattern(tagName, ignoreTagNameList)) {
                return "isIgnored";
            }
            return "isIgnored";
        }
        function $findPattern(where, patternsList) {
            where = Array.isArray(where) ? where : [where];
            for (let i = 0, lgt = where.length; i < lgt; i++) {
                for (let j = 0, lgt2 = patternsList.length; j < lgt2; j++) {
                    if (patternsList[j].test(where[i]))
                        return true;
                }
            }
        }
        function $testString(element, blackListTags, elementsByType) {
            let classList = typeof element.className === "string"
                ? element.className.split(" ") || []
                : [];
            let tagName = element.tagName.toLowerCase();
            let hasMondrian = false;
            let hasBoth = false;
            let str = "";
            for (let i = 0, lgt = elementsByType.isIgnoredThird.length; i < lgt; i++) {
                let currentIgnoredThirdElement = elementsByType.isIgnoredThird[i];
                if (currentIgnoredThirdElement.contains(element)) {
                    return "isIgnoredThird";
                }
            }
            blackListTags.map((item) => {
                if (item.test(tagName))
                    return "isNotMondrian";
            });
            // @ts-ignore
            if (tagName === "img" && element.src.match(/mondrian.claro.com.br/)) {
                return "isMondrian";
            }
            let className = classList.join(" ");
            hasMondrian = !!className.match(/mdn-[a-zA-Z\-]+/);
            str = className.replace(/(mdn|gtm)-[a-zA-Z\d\-]+/g, "").replace(/\s+/, "");
            hasBoth = hasMondrian && !!str.length;
            if (hasBoth) {
                return "isMerged";
            }
            else if (hasMondrian) {
                return "isMondrian";
            }
            else {
                return "isNotMondrian";
            }
        }
        return report;
    });
}
exports.measureWeb = measureWeb;
exports.default = measureWeb;
